export default function prefetchImage(url) {
    if (!url)
        return;
    try {
        const img = new window.Image();
        img.src = url;
    }
    catch (e) {
        // ignore
    }
}
